import { Button } from '@/components/Button/Button'

import styles from './styles.module.scss'

export const AnchorButton = ({ section, text, customClass }) => {
  return (
    <Button
      tagName="a"
      href="#planos"
      variant="primary"
      id={`${section}-wantToHire-button`}
      className={`${styles.anchorButton} ${customClass}`}
    >
      {text || 'Quero contratar'}
    </Button>
  )
}
